import { __awaiter, __extends, __generator, __values } from "tslib";
import axios from "axios";
import { CancelToken, isCancel } from "./components/select-source";
var token = window.kkToken;
var parts = location.host.split(".");
parts[0] = "api";
var apiRoot = location.protocol + "//" + parts.join(".") + "/";
var axiosInstance = axios.create({
    baseURL: apiRoot,
    withCredentials: true,
});
axiosInstance.defaults.headers["Cache-Control"] = "no-cache";
axiosInstance.defaults.headers.common["Accept-Language"] = window.language;
if (token) {
    axiosInstance.defaults.headers["X-Kuusakoski-Token"] = token;
}
var JsonRpcException = /** @class */ (function (_super) {
    __extends(JsonRpcException, _super);
    function JsonRpcException(error) {
        var _this = _super.call(this) || this;
        _this.error = error;
        return _this;
    }
    return JsonRpcException;
}(Error));
var serviceInvokeErrors = [];
var serviceErrorHandlers = [];
function invoker(path) {
    return function invoker(name, args, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, e_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("invoke", name, args);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axiosInstance.post("private/" + path, {
                                jsonrpc: "2.0",
                                method: name,
                                params: args,
                            }, {
                                cancelToken: cancelToken
                            })];
                    case 2:
                        response = _a.sent();
                        data = response.data;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1.response && e_1.response.data && e_1.response.data.jsonrpc && e_1.response.data.error) {
                            data = e_1.response.data;
                        }
                        else {
                            throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (data.error) {
                            error_1 = new JsonRpcException(data.error);
                            serviceInvokeErrors.push(error_1);
                            setTimeout(function () {
                                var e_2, _a;
                                var index = serviceInvokeErrors.findIndex(function (e) { return e === error_1; });
                                if (index === -1)
                                    return;
                                try {
                                    for (var serviceErrorHandlers_1 = __values(serviceErrorHandlers), serviceErrorHandlers_1_1 = serviceErrorHandlers_1.next(); !serviceErrorHandlers_1_1.done; serviceErrorHandlers_1_1 = serviceErrorHandlers_1.next()) {
                                        var handler = serviceErrorHandlers_1_1.value;
                                        handler(error_1);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (serviceErrorHandlers_1_1 && !serviceErrorHandlers_1_1.done && (_a = serviceErrorHandlers_1.return)) _a.call(serviceErrorHandlers_1);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }, 1);
                            throw error_1;
                        }
                        return [2 /*return*/, data.result];
                }
            });
        });
    };
}
function handleServiceError(error) {
    var index = serviceInvokeErrors.findIndex(function (e) { return e === error; });
    if (index != -1)
        serviceInvokeErrors.splice(index, 1);
    else
        throw error;
}
function onUnhandledServiceError(handler) {
    serviceErrorHandlers.push(handler);
}
function service(TService) {
    var path = TService.servicePath || TService.serviceName.match(/(.*)Service$/)[1].toLowerCase();
    return new TService(invoker(path));
}
export { CancelToken, isCancel, handleServiceError, onUnhandledServiceError, service, axiosInstance, apiRoot, };
